/** Session QCM invité (sans compte) : persistance locale avant/après choix d’un extrait public. */
export const GUEST_QCM_SESSION_KEY = 'guest_qcm_session';

export function readGuestQcmSession() {
    try {
        const raw = localStorage.getItem(GUEST_QCM_SESSION_KEY);
        if (!raw) return null;
        const o = JSON.parse(raw);
        const examId = String(o?.examId || '').trim();
        if (!examId) return null;
        return {
            examId,
            examType: o.examType || 'qcm',
            strategyId: o.strategyId || 'random',
        };
    } catch {
        return null;
    }
}

export function writeGuestQcmSession(payload) {
    localStorage.setItem(GUEST_QCM_SESSION_KEY, JSON.stringify(payload));
}

export function clearGuestQcmSession() {
    try {
        localStorage.removeItem(GUEST_QCM_SESSION_KEY);
    } catch {
        /* ignore */
    }
}
